<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #FFFFFF; height: 100vh;">
        <v-toolbar dense :color="'#FF9C00'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo2.png" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-row v-if="!pagoRealizado">
            <v-col class="text-center">
                <h1 class="ma-4">Puedes preguntarnos lo que quieras</h1>
            </v-col>
        </v-row>

        <v-row v-if="!pagoRealizado">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    Nos pondremos en contacto contigo lo antes posible.
                </p>
            </v-col>
        </v-row>

       
        <v-container v-if="reserva">
            <v-row>
                <v-col cols="12" md="4">
                    <v-card>
                        <v-card-title>
                            Consulta
                        </v-card-title>
                        <v-card-text>
                            <v-row dense class="mx-4">
                                <v-textarea v-model="reserva.comentarios"
                                    outlined label="Consulta" dense autocomplete="off"></v-textarea>
                            </v-row>

                           

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

           
            <v-row>
                <v-col align="end">
                    <v-btn class="mt-4" :disabled="!pasajerosCompletos || estado == 'pago'"
                        style="background-color: #FF9C00; color: black;" @click="_enviarConsulta">
                        ENVIAR CONSULTA
                    </v-btn>
                   
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    data() {
        return {
            comentario: '',
            reserva: null,
            pasajeros: [],
            estado: 'confirmacion',
            pagoRealizado: false,
            data: "eyJEc19BbW91bnQiOiIxNTM1MDAiLCJEc19DdXJyZW5jeSI6Ijk3OCIsIkRzX09yZGVyIjoiZVRNQ2xvIiwiRHNfTWVyY2hhbnRDb2RlIjoiMjYzMTAwMDAwIiwiRHNfVGVybWluYWwiOiI2MSIsIkRzX1Jlc3BvbnNlIjoiOTk5OCIsIkRzX0F1dGhvcmlzYXRpb25Db2RlIjoiIiwiRHNfVHJhbnNhY3Rpb25UeXBlIjoiRiIsIkRzX1NlY3VyZVBheW1lbnQiOiIwIiwiRHNfTGFuZ3VhZ2UiOiIxIiwiRHNfTWVyY2hhbnREYXRhIjoiIiwiRHNfVXJsUGFnbzJGYXNlcyI6Imh0dHBzOi8vc2lzLXQucmVkc3lzLmVzOjI1NDQzL3Npcy9wMmY_dD0yODNGQjE4QzkyQ0E1NTk0OTk3NDM0RUREM0Y5RkYwMzgwQ0E0Q0ExIiwiRHNfQ29udHJvbF8xNzM5OTc0NDMxMjc0IjoiMTczOTk3NDQzMTI3NCJ9",
        };
    },
    computed: {
        ...mapState(["nacionalidades"]),

        pasajerosCompletos() {
            return this.pasajeros.every(pasajero => {
                return pasajero.nombre; // && pasajero.nacionalidad;
            });
        }
    },
    mounted() {
        this.estado = 'confirmacion';
        const hash = this.$route.params.hash;
        console.log('hash:', hash);
        this.logout();
        if (hash != 'pagoRealizado') {
            this._getReservaByHash(hash);
        } else {
            this.pagoRealizado = true;
        }
    },
    methods: {
        ...mapMutations("auth", ["logout"]),
        ...mapActions("reservas", ["getReservaByHash", "confirmarPasajeros", "obtenerUrlPago"]),


        async _getReservaByHash(hash) {
            this.reserva = await this.getReservaByHash([hash]);
            console.log('res:', this.reserva);
            this.pasajeros = Array.from({ length: this.reserva.cant_peregrinos }, () => ({
                nombre: '',
                apellidos: '',
                dni: '',
                edadNacimiento: '',
                direccion: '',
                poblacion: '',
                provincia: '',
                nacionalidad: '',
                cp: ''
            }));
        },

        async _enviarConsulta() {
          //  var res = await this.enviarConsulta([this.reserva.id]);
          //  console.log('res:', res);
        },

        async _confirmarPasajeros() {
            var res = await this.confirmarPasajeros([this.pasajeros, this.reserva.id]);
            console.log('res:', res);
            if (res) {
                this.estado = 'pago';
                console.log('res:', this.estado);
            }
        },

        async _Pagar() {
            var res = await this.obtenerUrlPago([this.reserva.id]);
            console.log('res:', res);
            if (res && res.payment_url) {
                let buff = Buffer.from(res.payment_url, 'base64');
                let text = buff.toString('ascii');
                let decodedData = JSON.parse(text);
                let campo = decodedData.Ds_UrlPago2Fases;
                if (campo.startsWith('https')) {
                    window.open(campo, '_blank');
                }
            }



            /*   console.log(this.data);
               let buff = Buffer.from(this.data, 'base64');
               let text = buff.toString('ascii');
               let decodedData = JSON.parse(text);
               let campo = decodedData.Ds_UrlPago2Fases;
               if (campo.startsWith('https')) {
                   window.open(campo, '_blank');
               }
               console.log('campo:', campo);
               console.log('decoded data:', text);*/
        }
    },
};
</script>

<style scoped></style>
